import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/SpaceDashboardOutlined";
import BarChartIcon from "@mui/icons-material/BarChartOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlineOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";

const TABS = [
  { label: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
  { label: "Report",    icon: <BarChartIcon />,  path: "/report"    },
  { label: "Profile",   icon: <PersonIcon />,    path: "/profile"   },
  { label: "Settings",  icon: <SettingsIcon />,  path: "/settings"  },
];

const NAV_HEIGHT = 64;

export default function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const activeIdx = Math.max(
    0,
    TABS.findIndex((t) => location.pathname.startsWith(t.path))
  );

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.default",
      }}
    >
      <Box
        component="main"
        sx={{
          flex: 1,
          // Reserve space so the fixed nav doesn't cover content
          pb: `${NAV_HEIGHT + 8}px`,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Outlet />
      </Box>

      <Paper
        elevation={8}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: (t) => t.zIndex.appBar,
          borderTop: "1px solid",
          borderColor: "divider",
          borderRadius: 0,
        }}
      >
        <Box sx={{ maxWidth: 720, mx: "auto" }}>
          <BottomNavigation
            value={activeIdx}
            onChange={(_, idx) => navigate(TABS[idx].path)}
            showLabels
            sx={{
              height: NAV_HEIGHT,
              "& .MuiBottomNavigationAction-root": {
                minWidth: 0,
                fontSize: "0.6875rem",
                color: "text.secondary",
                "&.Mui-selected": {
                  color: "primary.main",
                },
              },
              "& .MuiBottomNavigationAction-label": {
                fontSize: isDesktop ? "0.75rem" : "0.6875rem",
                fontWeight: 600,
                "&.Mui-selected": { fontSize: isDesktop ? "0.75rem" : "0.6875rem" },
              },
            }}
          >
            {TABS.map((t) => (
              <BottomNavigationAction key={t.path} label={t.label} icon={t.icon} />
            ))}
          </BottomNavigation>
        </Box>
      </Paper>
    </Box>
  );
}
